import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN,
  USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS,
  USUARIO_PERFIL_BUSCAR_POR_ID_FAILURE,
  USUARIO_PERFIL_BUSCAR_POR_ID_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function buscarPorId(id, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN,
    data: id,
    callback,
  };
}

export function dismissBuscarPorIdError() {
  return {
    type: USUARIO_PERFIL_BUSCAR_POR_ID_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN actions
export function* doBuscarPorId(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioPerfilApi = new Services['UsuarioPerfilApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioPerfilApi.findById(action.data);
  } catch (err) {
    yield put({
      type: USUARIO_PERFIL_BUSCAR_POR_ID_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIO_PERFIL_BUSCAR_POR_ID_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchBuscarPorId() {
  yield takeLatest(USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN, doBuscarPorId);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN:
      return {
        ...state,
        registro: {},
        buscarPorIdPending: true,
        buscarPorIdError: null,
      };

    case USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS:
      return {
        ...state,
        registro: action.data,
        buscarPorIdPending: false,
        buscarPorIdError: null,
      };

    case USUARIO_PERFIL_BUSCAR_POR_ID_FAILURE:
      return {
        ...state,
        buscarPorIdPending: false,
        buscarPorIdError: action.data.error,
      };

    case USUARIO_PERFIL_BUSCAR_POR_ID_DISMISS_ERROR:
      return {
        ...state,
        buscarPorIdError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/buscarPorId.js